"use client";

import React, { useCallback, useState } from "react";
import {  Dropdown } from "react-bootstrap";
import Link from "next/link";
import {
  UserIcon,
  User01Icon,
  OrderIcon,
  FAQIcon,
  LogoutIcon,
} from "@/components/icons/navbar-icon";
import { useRouter } from "next/navigation";
import { useDispatch, useSelector } from "react-redux";
import { logout } from "@/redux/slices/authSlice";
import { fetchProfile } from "@/redux/slices/profileSlice";
import Cookies from "js-cookie";
import { WishlistIcon } from "@/components/icons/my-profile";
import Image from "next/image";

export default function UserProfile() {
  const dispatch = useDispatch();
  const router = useRouter();
  const token = Cookies.get("token");
  const profile = useSelector((state) => state.profiles.profile);
  const [hasFetched, setHasFetched] = useState(false);

  const handleLogout = useCallback(() => {
    dispatch(logout());
    router.refresh(); // Less blocking than reload
  }, [dispatch, router]);

  const handleToggle = useCallback(() => {
    if (token && !hasFetched) {
      dispatch(fetchProfile());
      setHasFetched(true);
    }
  }, [dispatch, token, hasFetched]);

  const renderUserInfo = () => {
    if (profile?.data?.profile_image) {
      return (
        <Image
          src={profile.data.profile_image}
          className="rounded-circle object-fit-cover d-inline-block"
          alt="User Image"
          width={40}
          height={40}
        />
      );
    }

    const initials = `${profile?.data?.first_name?.[0] || ""}${profile?.data?.last_name?.[0] || ""}`;
    return (
      <div
        className="rounded-circle d-inline-flex align-items-center justify-content-center text-white"
        style={{
          width: "40px",
          height: "40px",
          fontSize: "16px",
          backgroundColor: "#00968f",
        }}
      >
        {initials}
      </div>
    );
  };

  return (
    <Dropdown className="p-0 user-profile" align="end" onToggle={handleToggle}>
      <Dropdown.Toggle className="p-0 border-0 rounded-0" variant="transparent" id="dropdown-basic" aria-label="User Profile Menu"title="User Profile Menu">
        <UserIcon className="cursor-pointer"  aria-hidden="true" focusable="false"/>
      </Dropdown.Toggle>

      <Dropdown.Menu className="mt-3 rounded-2 custom-profile-drop-menu">
        {token ? (
          <div className="d-flex align-items-center gap-2 pb-3 border-bottom">
            {renderUserInfo()}
            <div className="ms-1">
              <h5 className="fw-medium text-capitalize">
                {profile?.data?.first_name} {profile?.data?.last_name}
              </h5>
              <span className="bg-transparent">{profile?.data?.phone_numbe}</span>
            </div>
          </div>
        ) : (
          <div className="d-flex align-items-start gap-2 without-login-drop-menu">
            <Image
              src="/assets/images/navbar/dummy-user.webp"
              className="rounded-circle object-fit-cover d-inline-block"
              alt="User Image"
              width={48}
              height={48}
            />
            <div className="ms-1">
              <Link href="/login" className="fw-medium text-capitalize cursor-pointer">
                Login or Register
              </Link>
              <p className="bg-transparent mt-1">
                To access account and manage orders
              </p>
            </div>
          </div>
        )}

        {token && (
          <>
            <Dropdown.Item href="/my-profile" className="p-2 rounded-1 d-flex align-items-center gap-2">
              <User01Icon />
              <p className="ms-1 text-capitalize">My Account</p>
            </Dropdown.Item>

            <Dropdown.Item href="/my-profile?tab=wishlist-tab" className="p-2 rounded-1 d-flex align-items-center gap-2">
              <WishlistIcon />
              <p className="ms-1 text-capitalize">Wishlist</p>
            </Dropdown.Item>

            <Dropdown.Item href="/my-profile?tab=my-order-tab" className="p-2 rounded-1 d-flex align-items-center gap-2">
              <OrderIcon />
              <p className="ms-1 text-capitalize">My Orders</p>
            </Dropdown.Item>

            <div className="border-bottom my-2 py-1"></div>

            <Dropdown.Item href="/my-profile?tab=faqs-tab" className="p-2 rounded-1 d-flex align-items-center gap-2">
              <FAQIcon />
              <p className="ms-1 text-capitalize">FAQs</p>
            </Dropdown.Item>

            <Dropdown.Item onClick={handleLogout} className="p-2 rounded-1 d-flex align-items-center gap-2">
              <LogoutIcon />
              <p className="ms-1 text-capitalize">Logout</p>
            </Dropdown.Item>
          </>
        )}
      </Dropdown.Menu>
    </Dropdown>
  );
}
// import React, { useEffect } from "react";
// import { Button, Dropdown, Image } from "react-bootstrap";
// import Link from "next/link";
// import {
//   UserIcon,
//   User01Icon,
//   OrderIcon,
//   Heart01Icon,
//   FAQIcon,
//   LogoutIcon,
// } from "@/components/icons/navbar-icon";
// import { useRouter } from "next/navigation";
// import { useDispatch, useSelector } from "react-redux";
// import { logout } from "@/redux/slices/authSlice";
// import { fetchProfile } from "@/redux/slices/profileSlice";
// import Cookies from "js-cookie";
// import { WishlistIcon } from "@/components/icons/my-profile";

// export default function UserProfile() {
//   const dispatch = useDispatch();
//   const router = useRouter();

//   const token = Cookies.get("token");

//   const handleLogout = () => {
//     dispatch(logout());
//     setTimeout(() => window.location.reload(), 1000);
// };


//   useEffect(() => {
//     if (token) {
//       dispatch(fetchProfile());
//     } else {
//       ("");
//     }
//   }, [dispatch, token]);

//   const profile = useSelector((state) => state.profiles.profile);

//   return (
//     <>
//       <Dropdown className="p-0 user-profile" align="end">
//         <Dropdown.Toggle
//           className="p-0 border-0 rounded-0 bg-transparent"
//           id="dropdown-basic"
//         >
//           <UserIcon className="cursor-pointer" />
//         </Dropdown.Toggle>

//         <Dropdown.Menu className="mt-3 rounded-2 custom-profile-drop-menu">
//           {token ? (
//             <div className="d-flex align-items-center gap-2 pb-3 border-bottom">
//               {profile?.data?.profile_image ? (
//                 <Image
//                   src={profile?.data?.profile_image}
//                   className="rounded-circle object-fit-cover d-inline-block"
//                   alt="User Image"
//                 />
//               ) : (
//                 <div
//                   className="rounded-circle d-inline-flex align-items-center justify-content-center text-white"
//                   style={{
//                     width: "40px",
//                     height: "40px",
//                     fontSize: "16px",
//                     backgroundColor: "#00968f",
//                   }}
//                 >
//                   {`${profile?.data?.first_name?.[0] || ""}${
//                     profile?.data?.last_name?.[0] || ""
//                   }`}
//                 </div>
//               )}
//               <div className="ms-1">
//                 <h5 className="fw-medium text-capitalize">
//                   {profile?.data?.first_name} {profile?.data?.last_name}
//                 </h5>
//                 <span className=" bg-transparent">
//                   {profile?.data?.phone_number}
//                 </span>
//               </div>
//             </div>
//           ) : (
//             <>
//                 <div className={`d-flex align-items-start gap-2 pb-3 without-login-drop-menu ${token ? 'border-bottom' : ''}`}>
//                   <Image
//                     src="/assets/images/navbar/dummy-user.svg"
//                     className="rounded-circle object-fit-cover d-inline-block"
//                     alt="User Image"
//                   />

//                   <div className="ms-1">
//                     <Link href="/login" className="fw-medium text-capitalize cursor-pointer">
//                       Login or Register
//                     </Link>

//                     <p className=" bg-transparent mt-1">
//                       To access account and manage orders
//                     </p>
//                 </div>
//               </div>
//             </>
//           )}
//            {token && (
//             <div className="mt-3 "    >
//               <Dropdown.Item
//                 href="/my-profile"
//                 className="p-2 rounded-1 d-flex align-items-center gap-2"
//               >
//                 <User01Icon />
//                 <p className="ms-1 text-capitalize">My Account</p>
//               </Dropdown.Item>
//             </div>
//           )}
//           {token && (
//             <div >
//               <Dropdown.Item
//                 href="/my-profile?tab=wishlist-tab"
//                 className="p-2 rounded-1 d-flex align-items-center gap-2"
//               >
//                 <WishlistIcon />
//                 <p className="ms-1 text-capitalize">Wishlist</p>
//               </Dropdown.Item>
//             </div>
//           )}
//           {token && (
//             <div >
//               <Dropdown.Item
//                 href="/my-profile?tab=my-order-tab"
//                 className="p-2 rounded-1 d-flex align-items-center gap-2"
//               >
//                 <OrderIcon />
//                 <p className="ms-1 text-capitalize">My Orders</p>
//               </Dropdown.Item>
//             </div>
//           )}
//           {token && <div className="border-bottom my-2 py-1"></div>}
//           {token && (
//             <Dropdown.Item
//               href="/my-profile?tab=faqs-tab"
//               className="p-2 rounded-1 d-flex align-items-center gap-2"
//             >
//               <FAQIcon />
//               <p className="ms-1 text-capitalize">FAQs</p>
//             </Dropdown.Item>
//           )}
//             {token && (
//               <Dropdown.Item
//                 onClick={handleLogout}
//                 className="p-2 rounded-1 d-flex align-items-center gap-2"
//               >
//                 <LogoutIcon />
//                 <p className="ms-1 text-capitalize">Logout</p>
//               </Dropdown.Item>
//             )}
//         </Dropdown.Menu>
//       </Dropdown>
//     </>
//   );
// }

